import React from 'react'
import { openPrivacy, URLButton } from './WelcomeUtils';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import translate from '../../../../i18n/translate';

function ProfileFooter(props:any) {
    const{openFooter,setOpenFooter,profileForm}=props
  return (
    <div className="footer-profile">
    <button
      onClick={() => setOpenFooter(!openFooter)}
      style={{
        cursor: "pointer",
        fontSize: !profileForm.isProfileForm ? "12px" : "14px",
        border: "none",
        background: "transparent",
      }}
      data-testid={'privacyButton'}
    >
      {!profileForm.isProfileForm
        ? 'Read why we collect your data '
        : "More information on the processing of your personal data can be found in the"}{" "}
      {profileForm.isProfileForm && (
        <URLButton className="privacy_terms_button" onClick={openPrivacy} >
          {translate("privacy_policy")}
        </URLButton>
      )}
       <KeyboardArrowDownIcon style={{fontSize:'1.2rem',color:'#5C5C51' }} />
    </button>
    {openFooter && (
      <div style={{ textAlign: "left", marginTop:'1rem' }}>
        <p>The information we collect may include, but is not limit to the following :</p>
        <ul style={{ paddingLeft: "20px" }}>
          <li>your first name, last name, email address and password to facilitate product support </li>
          <li>your country and time zone to personalise the user experience and for scheduling live classes</li>
          <li>your preferred contact method to continually improve your learning experience</li>
          <li>your contact number to provide our service and for direct or immediate communication</li>
          <li>your support language preference to guide our learning specialist team's communication with you</li>
        </ul>
        <p>
          Please note that all your sessions will take place in the virtual classroom, even if you specified a
          different contact method on boarding process
        </p>
        <p>
          For more information, read our{" "}
          <URLButton className="privacy_terms_button" onClick={openPrivacy}>
            {translate("privacy_policy")}
          </URLButton>
        </p>
      </div>
    )}
  </div>
  )
}

export default ProfileFooter
